export default "__VITE_ASSET__BRm3EhTj__"